import {
  Circle,
  Flex,
  HStack,
  Icon,
  IconButton,
  useToast,
} from "@chakra-ui/react";
import { css } from "@emotion/react";

import { useEffect, useState } from "react";
import { RiNotificationLine, RiUserAddLine } from "react-icons/ri";
import { api } from "../../services/api";

interface Response {
  _id: string;
  user: {
    name: string;
    cpfCnpj: string;
  }[];
  read: boolean;
  createdAt: Date;
}

export function NotificationsNav() {
  const toast = useToast();
  const [totalData, setTotalData] = useState(0);
  useEffect(() => {
    loadNotifications();
  }, []);

  const loadNotifications = async () => {
    try {
      const { data } = await api.get("/notifications", {
        params: {
          category: "support",
        },
      });

      const dataFormatted = data.data[0].data.filter(
        (item: Response) => item.read === false
      );

      console.log(dataFormatted);

      setTotalData(dataFormatted.length);
    } catch (error) {
      console.log(error);

      toast({
        title: "Erro ao carregar notificações",
        status: "error",
        isClosable: true,
      });
    }
  };
  return (
    <Flex bg="bg" h="20" align="center">
      <HStack
        spacing={["6", "8"]}
        mx={["4", "6"]}
        pr={["4", "6"]}
        py="1"
        color="gray_light"
        borderRightWidth={1}
        borderColor="gray"
      >
        <IconButton
          size="lg"
          css={css`
            position: relative !important;
          `}
          py={"2"}
          variant="ghost"
          aria-label="open menu"
          _hover={{
            bg: "none",
          }}
          icon={
            <>
              <RiNotificationLine color={"gray.750"} />

              {totalData > 0 && (
                <Circle
                  size="16px"
                  bg="tomato"
                  color="white"
                  position={"absolute"}
                  top={"6px"}
                  right={"6px"}
                  fontSize={"0.8rem"}
                  zIndex={9999}
                >
                  {totalData}
                </Circle>
              )}
            </>
          }
        />
      </HStack>
    </Flex>
  );
}
